import React from 'react'
import { Swiper, SwiperSlide } from '@components/molecules/Slider'

interface CarouselSlide {
  image: string
  aspectRatio: string
}

export interface SportsBeerImageCarouselData {
  slides: CarouselSlide[]
}

const SportsBeerImageCarousel: React.FC<SportsBeerImageCarouselData> = ({ slides }) => {
  if (!slides?.length) return null

  return (
    <div className="w-full">
      <Swiper
        loop={true}
        centeredSlides={true}
        slidesPerView={1.3}
        grabCursor={true}
        spaceBetween={20}
        pagination={{ el: '.sports-beer-carousel-pagination', clickable: true }}
        breakpoints={{
          481: { slidesPerView: 2.2, spaceBetween: 20 },
          1024: { slidesPerView: 3.5, spaceBetween: 32 },
        }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="relative"
              style={{ aspectRatio: slide.aspectRatio || '143/243' }}
            >
              {slide.image && (
                <img
                  src={slide.image}
                  alt=""
                  className="w-full h-full object-cover object-center"
                  loading="lazy"
                />
              )}
              <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100%-28px)] h-[calc(100%-28px)] border-[3px] border-[#CBFF00] z-[1]" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="sports-beer-carousel-pagination" />
    </div>
  )
}

export default SportsBeerImageCarousel
